import React from "react";
import { Form, Link } from "@remix-run/react";
import { IdentResponse } from "../api-bindings/ident.ts";

const HeaderAccount = (
  { ident, hideJoin, showSignIn }: {
    ident: IdentResponse | undefined;
    hideJoin: boolean | undefined;
    showSignIn: boolean | undefined;
  },
) => {
  // If the user is not signed in and we are hiding the join button, return nothing
  // happens on account creation routes
  if ((!ident || !ident.email) && hideJoin) return;

  if ((!ident || !ident.email) && !hideJoin) {
    return (
      <>
        <Link
          key={1}
          className="SignIn"
          to="https://talkingpointsmemo.com/memberships?utm_source=on_site&utm_medium=header_button&utm_campaign=memberships"
        >
          JOIN
        </Link>
        {showSignIn && (
          <Link
            key={2}
            className="SignIn"
            to="/signin"
          >
            SIGN IN
          </Link>
        )}
      </>
    );
  }

  let iconURI: string | undefined;
  if (ident.membership === "prime") {
    iconURI =
      "https://talkingpointsmemo.com/wp-content/themes/talkingpointsmemo/assets/images/logo/TPMRedes_PrimeLogo_Red.svg";
  }
  if (ident.membership === "adfree") {
    iconURI =
      "https://talkingpointsmemo.com/wp-content/themes/talkingpointsmemo/assets/images/logo/adfree-logo-icon-2.svg";
  }
  if (ident.membership === "inside") {
    iconURI =
      "https://talkingpointsmemo.com/wp-content/themes/talkingpointsmemo/assets/images/logo/inside-logo-icon.svg";
  }

  return (
    <>
      <Form
        method="post"
        action="/signout"
        key="2"
        style={{
          margin: "8px 0 8px 0",
        }}
        className="SignOut"
      >
        <button>
          SIGN OUT
        </button>
      </Form>
    </>
  );
};

export default HeaderAccount;
